import React, { useEffect, useRef, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, staffRequestAction, authActions } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import {
  exportDate,
  fDate,
  getCurrentDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import { getStoredValue } from "../../_helpers/storagehelper";

function MessageToInmate() {
  const dispatch = useDispatch();
  const facilityList = useSelector((x) => x?.facility?.facilityList);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const { ManagementUserID } = useSelector((x) => x?.auth?.user);
  const {
    formTitleForInmateMessageResponse,
    initiateInmateMessageList,
    messageToInmateSearchListData,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const { RequestStatus } = useSelector((x) => x?.dropdownOptions);

  const [reviewFullData, setReviewFullData] = useState([]);

  const prevFacilityCodeRef = useRef(facilityCode);

  const { isSignalRData } = useSelector((state) => state.auth);
  // const [inmateMessageList, setInmateMessageList] = useState({
  //   facilityID: facilityCode,
  //   InmatesId: 0,
  //   InmateResidentID: "",
  //   PodID: 0,
  //   RequestFormTypeId: 0,
  //   ManagementUserID: 1,
  //   UserFirstName: "",
  //   UserLastName: "",
  //   ActiveStatus: 2,
  //   CreateStartDate: "",
  //   CreateEndDate: "",
  //   RespondStartDate: "",
  //   RespondEndDate: "",
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  //   exportExcel: false,
  //   exportPDF: false,
  // });

  /* facility list */
  useEffect(() => {
    const searchList = { ...messageToInmateSearchListData };
    searchList.facilityID = facilityCode;
    searchList.ManagementUserID = ManagementUserID;
    dispatch(staffRequestAction?.getInitiateInmateMessageList(searchList))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...messageToInmateSearchListData };
          if (searchParams.PageNo != 1 || searchParams.RowCountPerPage != 10) {
            searchParams.RowCountPerPage = 10;
            searchParams.PageNo = 1;
            dispatch(
              staffRequestAction?.setMessageToInmateSearchList(searchParams)
            );
            dispatch(
              staffRequestAction?.getInitiateInmateMessageList(searchParams)
            );
          }
        }
      })
      .catch((err) => { });
  }, [
    messageToInmateSearchListData.RowCountPerPage,
    messageToInmateSearchListData.PageNo,
    facilityCode,
  ]);

  //signalR
  // useEffect(() => {
  //   if (isSignalRData?.type == "Request_AdminRemedy_CUD") {
  //     if (facilityCode === 0) return;
  //     const searchList = { ...messageToInmateSearchListData };
  //     searchList.facilityID = facilityCode;
  //     searchList.ManagementUserID = ManagementUserID;
  //     searchList.isNoLoading = true
  //     dispatch(staffRequestAction?.getInitiateInmateMessageList(searchList))
  //       .then((result) => {
  //         if (result?.payload?.DataList?.length === 0) {
  //           const searchParams = { ...messageToInmateSearchListData };
  //           searchParams.RowCountPerPage = 10;
  //           searchParams.PageNo = 1;
  //           dispatch(
  //             staffRequestAction?.setMessageToInmateSearchList(searchParams)
  //           );
  //           dispatch(
  //             staffRequestAction?.getInitiateInmateMessageList(searchParams)
  //           );
  //         }
  //       })
  //       .catch((err) => { });
  //   }
  // }, [isSignalRData, messageToInmateSearchListData.RowCountPerPage,
  //   messageToInmateSearchListData.PageNo,
  //   facilityCode,]);

  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    dispatch(
      staffRequestAction?.getInmateMessageCount({
        FacilityCode: facilityCode,
        ManagementUserID: ManagementUserID,
      })
    );
  }, []);

  //load facility drop down
  useEffect(() => {
    getFormTitle();
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    getFormTitle();
  }, [facilityCode]);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode && facilityCode === 0) {
      history.navigate("StaffRequestList");
    }
  }, [facilityCode]);

  const getFormTitle = () => {
    dispatch(
      staffRequestAction?.formTitleForInmateMessage({
        FacilityID: facilityCode,
      })
    );
  };

  const columns = [
    // {
    //   name: "Form Title",
    //   selector: (row) => row.RequestFormTitle,
    // cell: (row) => (
    //   <div
    //     onClick={() => viewForm(row, reviewFullData)}
    //     className="Common_Link_Style"
    //   >
    //     {row.RequestFormTitle}
    //   </div>
    // ),
    //   sortable: true,
    // },
    {
      name: "Form Title",
      key: "RequestFormTitle",
      selector: (row) => row.RequestFormTitle,
      cell: (row) => (
        <div className={`d-flex flex-wrap gap-2 align-items-start `}>
          <div
            className="Common_Link_Style"
            onClick={() => viewForm(row, reviewFullData)}
          >
            {row.RequestFormTitle}
          </div>
          {row?.UserRequestReadStatus === 0 &&
            row?.ManagementUserID === ManagementUserID && (
              <div class="newbutton-container">
                New
                <div class="border-animation"></div>
              </div>
            )}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Initiated By",
      key: "ManagementUserName",
      selector: (row) => row.ManagementUserName,
      sortable: true,
    },
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Full Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      sortable: true,
    },

    {
      width: "160px",
      name: "Created On",
      key: "RequestCreateDate",
      selector: (row) => row.RequestCreateDate,
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {row.RequestCreateDate || "-"}
          </div>
        </div>
      ),
    },
    {
      width: "160px",
      name: "Responded On",
      key: "RequestRespondDate",
      selector: (row) => row.RequestRespondDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {row.RequestRespondDate || "-"}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "RequestCurrentStatus",
      selector: (row) => row.RequestCurrentStatus,
      cell: (row) =>
        row.RequestCurrentStatus === "Open" ? (
          <span
            style={{ marginleft: "10px !important" }}
            className="status-open"
            title={row.RequestCurrentStatus}
          >
            Open
          </span>
        ) : (
          <span
            style={{ marginleft: "10px !important" }}
            className="status-Closed"
            title={"Closed"}
          >
            Closed
          </span>
        ),
      sortable: true,
      center: true,
      sortFunction: (rowA, rowB) => {
        // Ensuring case-insensitive sorting
        const statusA = rowA.RequestCurrentStatus.toLowerCase();
        const statusB = rowB.RequestCurrentStatus.toLowerCase();

        if (statusA < statusB) {
          return -1;
        }
        if (statusA > statusB) {
          return 1;
        }
        return 0;
      },
    },
  ];

  // const data = [
  //   {
  //     FacilityCode: 101,
  //     FacilityName: 101,
  //     City: "klkl",
  //   },
  // ];

  // const navigateToInmateForm = (row) => {
  // history.navigate("StaffRequestList/MessageToInmateRequestForm", {
  //   state: {
  //     formID: row?.RequestFormTypeID,
  //     RequestFormType: row?.RequestFormType,
  //     RequestFormTypeID: row?.RequestFormTypeID,
  //     InmateID: row?.InmateID,
  //     InmateResidentId: row?.InmateResidentId,
  //     formDetails: formDetails,
  //   },
  // });
  // };

  const handleRowPerPage = (page) => {
    const searchList = { ...messageToInmateSearchListData };
    searchList.RowCountPerPage = page;
    searchList.PageNo = 1;
    dispatch(staffRequestAction?.setMessageToInmateSearchList(searchList));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const searchList = { ...messageToInmateSearchListData };
    searchList.PageNo = page;
    dispatch(staffRequestAction?.setMessageToInmateSearchList(searchList));
    // setInmateMessageList((prevState) => ({
    //   ...prevState,
    //   PageNo: page,
    // }));
  };

  let sorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    sorting = true;
    const search = { ...messageToInmateSearchListData };
    const newSortOrder = search.SortBy.includes(column.key)
      ? search.SortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.facilityID = facilityCode;
    search.ManagementUserID = ManagementUserID;
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(staffRequestAction?.setMessageToInmateSearchList(search));
    dispatch(
      staffRequestAction?.getInitiateInmateMessageList({
        ...search,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
    // dispatch(staffRequestAction?.loadInmateRequestForumThreadList(search));
  };

  const handleChange = (e, select) => {
    const searchList = { ...messageToInmateSearchListData };
    searchList.facilityID = facilityCode;
    // searchList.PageNo = 1;
    // searchList.RowCountPerPage = 10;
    searchList.ManagementUserID = ManagementUserID;
    if (select === "RequestFormTypeId" || select === "ActiveStatus") {
      searchList[select] =
        e?.value !== undefined
          ? e?.value
          : select === "RequestFormTypeId"
            ? 0
            : select === "ActiveStatus"
              ? 2
              : "";
      searchList.PageNo = 1;
      searchList.RowCountPerPage = 10;
      dispatch(staffRequestAction?.setMessageToInmateSearchList(searchList));
      // setInmateMessageList(searchList);
      dispatch(staffRequestAction?.getInitiateInmateMessageList(searchList));
      return;
    }

    if (
      select === "CreateStartDate" ||
      select === "CreateEndDate" ||
      select === "RespondStartDate" ||
      select === "RespondEndDate"
    ) {
      searchList[select] = fDate(e);
      dispatch(staffRequestAction?.setMessageToInmateSearchList(searchList));
      // setInmateMessageList(searchList);
      // dispatch(staffRequestAction?.getInitiateInmateMessageList(searchList));
      return;
    }
    const { value } = e?.target;
    if (select === "InmateResidentID") {
      const regex = /^\d*$/;
      if (!regex.test(value)) return;
    }
    searchList[select] = value;
    dispatch(staffRequestAction?.setMessageToInmateSearchList(searchList));

    // setInmateMessageList(searchList);
    // if (select === "stateNameID" || select === "activeStatus") {
    //   setInmateMessageList((prevState) => ({
    //     ...prevState,
    //     [select]: e?.value,
    //   }));
    //   const updatedObj = {
    //     ...inmateMessageList,
    //     [select]: e?.value,
    //   };
    //   // dispatch(facilityAction?.getFacilityList(updatedObj));
    //   return;
    // }
    // const { name, value } = e?.target;
    // setInmateMessageList((prevState) => ({
    //   ...prevState,
    //   [name]: value,
    // }));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    const searchList = { ...messageToInmateSearchListData };
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "CreateStartDate") {
      if (
        searchList.CreateEndDate &&
        new Date(value) > new Date(searchList.CreateEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "CreateEndDate") {
      if (
        searchList.CreateStartDate &&
        new Date(value) < new Date(searchList.CreateStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...searchList,
      CreateStartDate:
        fieldName === "CreateStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : searchList.CreateStartDate, // preserve existing value
      CreateEndDate:
        fieldName === "CreateEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : searchList.CreateEndDate, // preserve existing value
    };
    dispatch(staffRequestAction?.setMessageToInmateSearchList(updatedParam));
  };

  const handleResDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "RespondStartDate") {
      if (
        messageToInmateSearchListData.RespondEndDate &&
        new Date(value) > new Date(messageToInmateSearchListData.RespondEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "RespondEndDate") {
      if (
        messageToInmateSearchListData.RespondStartDate &&
        new Date(value) <
        new Date(messageToInmateSearchListData.RespondStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...messageToInmateSearchListData,
      RespondStartDate:
        fieldName === "RespondStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : messageToInmateSearchListData.RespondStartDate, // preserve existing value
      RespondEndDate:
        fieldName === "RespondEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : messageToInmateSearchListData.RespondEndDate, // preserve existing value
    };
    dispatch(staffRequestAction?.setMessageToInmateSearchList(updatedParam));
  };

  const viewForm = (row, formDetails) => {
    history.navigate("StaffRequestList/MessageToInmateRequestForm", {
      state: {
        RequestForumMGUserThreadID: row?.RequestForumMGUserThreadID,
        formID: row?.RequestFormTypeID,
        RequestFormType: row?.RequestFormType,
        RequestFormTypeID: row?.RequestFormTypeID,
        InmateID: row?.InmateID,
        InmateResidentId: row?.InmateResidentId,
        formDetails: formDetails,
        sourceFrom: "MessageToInmate",
      },
    });
  };

  // const handleReviewRequest = () => {
  //   dispatch(staffRequestAction?.updateIndexValue(0));
  //   const searchData = { ...messageToInmateSearchListData };
  //   searchData.RowCountPerPage = 1000;
  //   searchData.PageNo = 1;
  //   searchData.isReviewData = true;
  //   dispatch(staffRequestAction?.setMessageToInmateSearchList(searchData));
  //   dispatch(staffRequestAction?.getInitiateInmateMessageList(searchData))
  // .then((result) => {
  //   const data = result?.payload?.DataList;
  //   setReviewFullData(data?.payload);
  //   viewForm(data[0], result?.payload);
  //   dispatch(staffRequestAction?.updateReviewStatus(true));
  // })
  // .catch((err) => {
  //   showToastNotification("Failed to get Review data", "error");
  // });
  // };
  const handleReviewRequest = () => {
    const searchData = { ...messageToInmateSearchListData };
    dispatch(staffRequestAction?.updateIndexValue(0));
    if (searchData?.ActiveStatus === 2 || searchData?.ActiveStatus === 3) {
      // const reviewData = {
      //   facilityID: facilityCode,
      //   inmatesId: 0,
      //   inmateResidentID: "",
      //   podID: 0,
      //   requestFormTypeID: 0,
      //   managementUserID: ManagementUserID,
      //   inmateFirstName: "",
      //   inmateLastName: "",
      //   reqCurrentStatus: 2,
      //   requestCreateStartDate: "",
      //   requestCreateEndDate: "",
      //   requestRespondStartDate: "",
      //   requestRespondEndDate: "",
      //   PageNo: 1,
      //   RowCountPerPage: 1000,
      // };
      searchData.facilityID = facilityCode;
      searchData.ActiveStatus =
        searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
      searchData.ManagementUserID = ManagementUserID;
      searchData.PageNo = 1;
      // searchData.RowCountPerPage = 10;
      searchData.RowCountPerPage = initiateInmateMessageList?.TotalRecordCount;
      dispatch(staffRequestAction?.LoadMGUserRequestReviewDataList(searchData))
        .then((result) => {
          const data = result?.payload?.DataList;
          if (data?.length > 0) {
            setReviewFullData(data?.payload);
            viewForm(data[0], result?.payload);
            dispatch(staffRequestAction?.updateReviewStatus(true));
          } else {
            showToastNotification("There is no requests in NEW status.");
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get Review data", "error");
        });
    } else {
      showToastNotification("There is no requests in NEW status.");
    }
  };

  const handleSearchReset = () => {
    const searchData = { ...messageToInmateSearchListData };
    searchData.facilityID = facilityCode;
    searchData.InmatesId = 0;
    searchData.InmateResidentID = "";
    searchData.PodID = 0;
    searchData.RequestFormTypeId = 0;
    searchData.ManagementUserID = ManagementUserID;
    searchData.UserFirstName = "";
    searchData.UserLastName = "";
    searchData.ActiveStatus = 2;
    searchData.CreateStartDate = "";
    searchData.CreateEndDate = "";
    searchData.RespondStartDate = "";
    searchData.RespondEndDate = "";
    searchData.PageNo = 1;
    searchData.RowCountPerPage = 10;
    searchData.SortBy = "RequestCreateDate DESC";
    dispatch(staffRequestAction?.resetMessageToInmateSearchList());
    dispatch(staffRequestAction?.getInitiateInmateMessageList(searchData));
    //updating notification
    dispatch(
      masterActions.GetLoadNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityCode,
      })
    )
      .then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      })
      .then((x) => {
        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });
      });
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = [
      "Form Title",
      "Initiated By",
      "Inmate ID",
      "Inmate Full name",
      "Created On",
      "Responded On",
      "Status",
    ];

    const search = { ...messageToInmateSearchListData };
    search.facilityID = facilityCode;
    search.ManagementUserID = ManagementUserID;
    search.RowCountPerPage = initiateInmateMessageList?.TotalRecordCount;
    search.exportExcel = true;
    search.PageNo = 1;
    // dispatch(staffRequestAction?.setMessageToInmateSearchList(search));

    dispatch(staffRequestAction?.getInitiateInmateMessageList(search))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            "Form Title": obj.RequestFormTitle,
            "Initiate By": obj.ManagementUserName,
            "Inmate ID": obj.InmateResidentId,
            "Inmate Full name": obj.InmateName,
            "Created On": obj.RequestCreateDate,
            "Responded On": obj.RequestRespondDate,
            Status: obj.RequestCurrentStatus === "Open" ? "Open" : "Closed",
          }));
        const currentTime = exportDate(new Date());

        generateXlsx(
          exportData,
          generateExcelColumns,
          `MessageInfo_${currentTime}`
        );
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const search = { ...messageToInmateSearchListData };
    search.facilityID = facilityCode;
    search.ManagementUserID = ManagementUserID;
    search.PageNo = 1;
    search.RowCountPerPage = 10;
    dispatch(staffRequestAction?.getInitiateInmateMessageList(search));
    dispatch(staffRequestAction?.setMessageToInmateSearchList(search));
    //updating notification
    dispatch(
      masterActions.GetLoadNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityCode,
      })
    )
      .then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      })
      .then((x) => {
        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });
      });
  };

  const handleNavigate = () => {
    history?.navigate("StaffRequestList");
    dispatch(staffRequestAction?.resetStaffRequestSearcList());
    dispatch(staffRequestAction?.resetPublicDefenderSearchList());
  };

  if (loading) {
    return <CustomLoader />;
  }

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={formTitleForInmateMessageResponse}
                name="RequestFormTypeId"
                label="Form Title"
                handleChange={(e) => handleChange(e, "RequestFormTypeId")}
                value={messageToInmateSearchListData?.RequestFormTypeId}
                isClearable={messageToInmateSearchListData?.RequestFormTypeId}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="ActiveStatus"
                options={RequestStatus}
                label="Status"
                value={messageToInmateSearchListData?.ActiveStatus}
                handleChange={(e) => handleChange(e, "ActiveStatus")}
                isClearable={messageToInmateSearchListData?.ActiveStatus !== 2}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                label="Inmate ID"
                placeholder="Enter Inmate ID"
                handleChange={(e) => handleChange(e, "InmateResidentID")}
                value={messageToInmateSearchListData?.InmateResidentID}
                maxLength={10}
              />
            </div>
          </div>
          {/* <div className="col-md-4">
                <div className="form-floating mb-3">
                  <DateInput
                    label="Created Start Date"
                    name="StartDate"
                    handleChange={(e) => handleChange(e, "StartDate")}
                    placeholderText="Select a date"
                    yearDropDown={true}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating mb-3">
                  <DateInput
                    label="Created End Date"
                    name="StartDate"
                    handleChange={(e) => handleChange(e, "toDate")}
                    placeholderText="Select a date"
                    yearDropDown={true}
                  />
                </div>
              </div> */}

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="UserLastName"
                label="Inmate Last Name"
                placeholder="Inmate Last Name"
                maxLength={30}
                handleChange={(e) => handleChange(e, "UserLastName")}
                value={messageToInmateSearchListData?.UserLastName}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="UserFirstName"
                label="Inmate First Name"
                placeholder="Inmate First Name"
                maxLength={30}
                handleChange={(e) => handleChange(e, "UserFirstName")}
                value={messageToInmateSearchListData?.UserFirstName}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Created Start Date"
                name="CreateStartDate"
                handleChange={(e) => handleChange(e, "CreateStartDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                value={messageToInmateSearchListData?.CreateStartDate}
                maxDate={
                  messageToInmateSearchListData?.CreateEndDate !== ""
                    ? messageToInmateSearchListData?.CreateEndDate
                    : getCurrentDate()
                }
                minDate={new Date(2017, 0, 1)}
                isClearable={
                  messageToInmateSearchListData?.CreateStartDate !== ""
                }
                handleBlur={(e) => handleDateBlur(e, "CreateStartDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "CreateStartDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Created End Date"
                name="CreateEndDate"
                handleChange={(e) => handleChange(e, "CreateEndDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                value={messageToInmateSearchListData?.CreateEndDate}
                maxDate={new Date()}
                minDate={
                  messageToInmateSearchListData?.CreateStartDate !== ""
                    ? messageToInmateSearchListData?.CreateStartDate
                    : new Date(2017, 0, 1)
                }
                isClearable={
                  messageToInmateSearchListData?.CreateEndDate !== ""
                }
                handleBlur={(e) => handleDateBlur(e, "CreateEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "CreateEndDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response Start Date"
                name="RespondStartDate"
                handleChange={(e) => handleChange(e, "RespondStartDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                value={messageToInmateSearchListData?.RespondStartDate}
                maxDate={
                  messageToInmateSearchListData?.RespondEndDate !== ""
                    ? messageToInmateSearchListData?.RespondEndDate
                    : getCurrentDate()
                }
                minDate={new Date(2017, 0, 1)}
                isClearable={
                  messageToInmateSearchListData?.RespondStartDate !== ""
                }
                handleBlur={(e) => handleResDateBlur(e, "RespondStartDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "RespondStartDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response End Date"
                name="RespondEndDate"
                handleChange={(e) => handleChange(e, "RespondEndDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                value={messageToInmateSearchListData?.RespondEndDate}
                maxDate={new Date()}
                minDate={
                  messageToInmateSearchListData?.RespondStartDate !== ""
                    ? messageToInmateSearchListData?.RespondStartDate
                    : new Date(2017, 0, 1)
                }
                isClearable={
                  messageToInmateSearchListData?.RespondEndDate !== ""
                }
                handleBlur={(e) => handleResDateBlur(e, "RespondEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "RespondEndDate")}
              />
            </div>
          </div>
        </div>

        <div className="row"></div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  return (
    <div className="message-to-inmate">
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        {/* web only */}
        <div className="d-none d-md-block card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <h2 className=" mb-4 text-color">INMATE MESSAGE SEARCH</h2>
            <div className="d-flex flex-wrap gap-1 align-items-center">
              <Button
                label="Back"
                type="button"
                status="primary"
                icon={"fa-solid fa-angle-left"}
                onClick={() => {
                  handleNavigate();
                }}
              />
            </div>
          </div>
          {renderSearch()}
        </div>

        {/* Mobile only */}
        <div className="d-block d-md-none w-100 d-flex justify-content-end align-items-center mt-2">
          <Button
            label="Back"
            type="button"
            className={"flex-shrink-0"}
            icon={"fa-solid fa-angle-left"}
            status="primary"
            onClick={() => {
              handleNavigate();
            }}
          />
        </div>
        <div className="d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
          <div className="row justify-content-end mb-2 d-none d-md-block">
            <div className="col-auto">
              <Button
                label="Back"
                type="button"
                className={"flex-shrink-0"}
                icon={"fa-solid fa-angle-left"}
                status="primary"
                onClick={() => {
                  handleNavigate();
                }}
              />
            </div>
          </div>
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">
              INMATE MESSAGE SEARCH
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
          {showSearchFields && renderSearch()}
        </div>

        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100 resp-space">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <h2 className=" mb-4 text-color">INMATE MESSAGES LIST</h2>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              {initiateInmateMessageList &&
                initiateInmateMessageList?.DataList &&
                initiateInmateMessageList?.DataList?.length > 0 && (
                  <Button
                    onClick={() => handleReviewRequest()}
                    variant="secondary"
                    className="me-2"
                    label="Review Request Here"
                    type="button"
                    icon={"fa-solid fa-file-circle-check"}
                    status="btn-label"
                    disabled={false}
                  />
                )}
              <Button
                variant="success"
                className="me-2"
                onClick={() =>
                  history.navigate("/Admin/StaffRequestList/Add", {
                    state: { createFormSource: "messageToInmate" },
                  })
                }
                label="Create New"
                type="button"
                status="btn-label"
                disabled={false}
                //icon={"circle-plus"}
                imgsrc={AddIcon}
              />
              {initiateInmateMessageList &&
                initiateInmateMessageList?.DataList &&
                initiateInmateMessageList?.DataList?.length > 0 && (
                  <ExcelExport handleExcelExport={exportDocAsExcel} />
                )}
            </div>
          </div>

          <Table
            columns={columns}
            data={initiateInmateMessageList?.DataList}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={initiateInmateMessageList?.TotalRecordCount}
            currentPage={messageToInmateSearchListData?.PageNo}
            paginationPerPage={messageToInmateSearchListData.RowCountPerPage}
            serverSideSort
            onSort={handleSort}
            sortColumn={messageToInmateSearchListData?.SortBy?.split(" ")[0]}
            sortDirection={messageToInmateSearchListData?.SortBy?.split(" ")[1]}
          />
        </div>
        {/* </form> */}
      </div>
    </div>
    // </div>
  );
}

export default React.memo(MessageToInmate);
